import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 300px;
  background-color: #fff;
  margin: auto;
  width: 600px;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.15);
  padding: 0px 40px;
  margin-top: 30px;
  border-radius: 3.76284px;
`;

export const SubTitle = styled.p`
  font-size: 14px;
  color: #373737;
  font-weight: 700;
  margin-bottom: 32px;
  text-align: center;
`;
